import { format, setDefaultOptions } from "date-fns";
import da from "date-fns/locale/da";
setDefaultOptions({ locale: da });

export const dateMonthYearTime = (
	date,
	datePrefix = true,
	timePrefix = true,
) => {
	date = new Date(date);
	return `${datePrefix ? "den" : ""} ${format(new Date(date), "d. MMMM yyyy,")}
			${timePrefix ? "kl" : ""}
			${format(new Date(date), "HH.mm")}`;
};
